import React from 'react';
import { FormHelpers } from '../Form/Form';

export interface FormStepProps {
  validationSchema?: any;
  onSubmit?: (values: any, helpers: FormHelpers) => void | Promise<void>;
}

const FormStep: React.FC<FormStepProps> = ({ children }) => <>{children}</>;

export default FormStep;
